import { AdapterResult, ParsedTxn } from '../money.model';
import { parseUsDate, parseAmountCents } from './parse-values';
import { normalizeApple } from './normalize';
import { APPLE_ACCOUNT_ID } from './detect-source';

const col = (header: string[], name: string): number =>
  header.findIndex(h => (h ?? '').replace(/^﻿/, '').trim().toLowerCase() === name.toLowerCase());

export function adaptAppleCard(rows: string[][]): AdapterResult {
  const [header, ...body] = rows;
  const iDate     = col(header, 'Transaction Date');
  const iDesc     = col(header, 'Description');
  const iMerchant = col(header, 'Merchant');
  const iCategory = col(header, 'Category');
  const iType     = col(header, 'Type');
  const iAmount   = col(header, 'Amount (USD)');
  const iBy       = col(header, 'Purchased By');

  const txns: ParsedTxn[] = body
    .filter(r => (r[iDate] ?? '').trim() !== '')
    .map(r => {
      const merchant    = (r[iMerchant] ?? '').trim();
      const description = (r[iDesc] ?? '').trim();
      return {
        date: parseUsDate(r[iDate]),
        // Apple exports purchases positive; internally money out is negative.
        amount: -parseAmountCents(r[iAmount]),
        description,
        merchant,
        matchKey: normalizeApple(merchant, description),
        accountId: APPLE_ACCOUNT_ID,
        source: 'apple-card' as const,
        isTransfer: (r[iType] ?? '').trim().toLowerCase() === 'payment',
        purchasedBy: (r[iBy] ?? '').trim(),
        sourceCategory: (r[iCategory] ?? '').trim(),
      };
    });

  return {
    source: 'apple-card', txns, balances: [], pendingCount: 0,
    accountMask: '', accountKind: 'credit',
  };
}
